"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageSizeOption = void 0;
exports.pageSizeOption = [
    { id: 12, name: '12' },
    { id: 24, name: '24' },
    { id: 36, name: '36' },
];
